export default __webpack_public_path__ + "a650e43dfb29070e550d17a9905ca28c.svg";